"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMessageHandler = void 0;
const mappers_1 = require("../mappers");
const models_1 = require("../models");
const MapperUtils_1 = require("../utils/MapperUtils");
const MessageUtil_1 = require("./MessageUtil");
class SendMessageHandler {
    constructor(socketAdapter, config, chat, chatType, chatId, 
    // TODO: Abstract the image cache to a separate layer. Also use a key that can uniquely identify the image instead of message id, e.g. s3 url. So the message related context doesn't leak into the cache abstraction.
    mediaBlobMap, userDirectory) {
        this.socketAdapter = socketAdapter;
        this.chat = chat;
        this.config = config;
        this.chatType = chatType;
        this.chatId = chatId;
        this.mediaBlobMap = mediaBlobMap;
        this.userDirectory = userDirectory;
    }
    sendMedia(mediaDraft, responseCallback) {
        const type = (0, MessageUtil_1.fileType)(mediaDraft.mediaFile);
        const messagePayload = Object.assign(Object.assign({}, (0, MessageUtil_1.mediaMessageBody)(mediaDraft, type)), { type: models_1.MESSAGE_TYPE.NORMAL });
        return this.sendMediaMessage(messagePayload, responseCallback);
    }
    sendInfo() { }
    sendNormal(payload, responseCallback) {
        const messagePayload = Object.assign(Object.assign(Object.assign({}, payload), { type: payload.mentionedUsers && payload.mentionedUsers.length > 0
                ? models_1.MESSAGE_TYPE.ACKNOWLEDGE
                : payload.replyToMessageData
                    ? models_1.MESSAGE_TYPE.REPLY
                    : models_1.MESSAGE_TYPE.NORMAL, contentType: models_1.MESSAGE_CONTENT_TYPE.TEXT }), (payload.replyToMessageData && {
            replyTo: (0, mappers_1.messageUnmapper)(payload.replyToMessageData),
        }));
        delete messagePayload.replyToMessageData;
        return this.sendMessage(messagePayload, responseCallback);
    }
    sendPriority(payload, responseCallback) {
        const messagePayload = Object.assign(Object.assign({}, payload), { type: models_1.MESSAGE_TYPE.PRIORITY, contentType: models_1.MESSAGE_CONTENT_TYPE.TEXT });
        return this.sendMessage(messagePayload, responseCallback);
    }
    sendReminder(payload, responseCallback) {
        const messagePayload = Object.assign(Object.assign({}, payload), { type: models_1.MESSAGE_TYPE.REMINDER, contentType: models_1.MESSAGE_CONTENT_TYPE.REMINDER });
        return this.sendMessage(messagePayload, responseCallback);
    }
    sendLocation(payload, responseCallback) {
        const messagePayload = Object.assign(Object.assign({}, payload), { type: models_1.MESSAGE_TYPE.NORMAL, contentType: models_1.MESSAGE_CONTENT_TYPE.LOCATION });
        return this.sendMessage(messagePayload, responseCallback);
    }
    sendMessage(payload, responseCallback, onTimeout) {
        const links = (0, MessageUtil_1.getLinkOnText)(payload.body);
        // Update payload if links are found
        if (links.length > 0) {
            payload.links = links;
            payload.contentType = models_1.MESSAGE_CONTENT_TYPE.LINK;
        }
        const finalPayload = this.createPayloadRequest(payload);
        this.socketAdapter.sendMessage(finalPayload, responseCallback, onTimeout);
        return finalPayload;
    }
    editMessage(payload, responseCallback, onTimeout) {
        const links = (0, MessageUtil_1.getLinkOnText)(payload.body);
        const editPayload = Object.assign(Object.assign({}, payload), (links.length > 0 && { links }));
        this.socketAdapter.editMessage(editPayload, responseCallback, onTimeout);
        return editPayload;
    }
    markMessageAsRead(message) {
        const onMarkMessageAsReadResponse = (data) => {
            var _a;
            if (data.statusCode === 200) {
                let { groupType } = this.chat;
                if ((groupType === models_1.GROUP_TYPE.PATIENT ||
                    groupType === models_1.GROUP_TYPE.NON_PATIENT) &&
                    ((_a = this.chat.settings) === null || _a === void 0 ? void 0 : _a.hidden)) {
                    groupType = models_1.GROUP_TYPE.HIDDEN;
                }
            }
        };
        this.socketAdapter.markMessageAsRead(message, onMarkMessageAsReadResponse);
    }
    sendMediaMessage(payload, responseCallback) {
        const payloadRequestData = this.createPayloadRequest(payload);
        this.socketAdapter.sendMessage(payloadRequestData, responseCallback);
        return payloadRequestData;
    }
    createPayloadRequest(payload) {
        const timestamp = Date.now();
        const platformType = this.config.platformType.toLowerCase();
        return Object.assign(Object.assign({}, payload), { chatType: this.chatType, messageId: `${platformType}_${(0, MapperUtils_1.randomIdGenerator)(5)}_${timestamp}`, senderTimestamp: `${platformType}_${timestamp}`, to: this.chat.id });
    }
    sendFormMessage(payload, responseCallback, onTimeout) {
        var _a, _b;
        const messagePayload = Object.assign(Object.assign({}, payload), { form: Object.assign(Object.assign({}, payload.form), { filledAs: (_a = payload.form) === null || _a === void 0 ? void 0 : _a.filledAs, templateType: (_b = payload.form) === null || _b === void 0 ? void 0 : _b.templateType, filledByAdmin: this.userDirectory.currentUserProfile.type === models_1.USER_TYPE.ADMIN ||
                    this.userDirectory.currentUserProfile.type === models_1.USER_TYPE.STAFF }), type: models_1.MESSAGE_TYPE.NORMAL, contentType: models_1.MESSAGE_CONTENT_TYPE.FORM });
        return this.sendMessage(messagePayload, responseCallback, onTimeout);
    }
}
exports.SendMessageHandler = SendMessageHandler;
